module.exports = __webpack_public_path__ + "static/media/phonepe.530b99ce.png";